<template>
  <div class="wrapper">
    <div class="container">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="myCouponsList.length?'没有更多了':''"
          @load="getdata"
        >
          <div class="no" v-if="myCouponsList.length == 0">
            <img src="./../../assets/images/icon_gwcwsp.svg" alt>
            <div>暂无历史优惠券</div>
          </div>
          <div class="container">
            <div class="couponbox" v-for="(item,index) in myCouponsList" :key="index">
              <!-- 分割线 -->
              <div class="line">
                <div class="circle c_t"></div>
                <div class="circle c_b"></div>
              </div>
              <!-- 左侧满减券 -->
              <div class="left" v-if="item.limit_condition!=0">
                <!-- 减得金额 -->
                <div class="top">
                  <span class="icon red">￥</span>
                  <span class="money">{{parseFloat(parseFloat(item.limit_amount).toFixed(2))}}</span>
                </div>
                <div class="bot">
                  满<span class="icon">￥</span>{{parseFloat(parseFloat(item.limit_condition).toFixed(2))}}使用
                </div>
              </div>
              <!-- 左侧无门槛券 -->
              <div class="left" v-if="item.limit_condition==0">
                <!-- 减得金额 -->
                <div class="top">
                  <span class="icon red">￥</span>
                  <span class="money">{{parseFloat(parseFloat(item.limit_amount).toFixed(2))}}</span>
                </div>
                <div class="bot">无门槛券</div>
              </div>
              <div class="mid">
                <span class="top">{{item.name}}</span>
                <span class="bot">{{item.end_time}} 到期</span>
              </div>
              <div class="right" v-if="item.is_use=='1'">
                已使用
                <!--<img src='./../../assets/images/icon_ygq.svg' class='yishixiao'/>-->
              </div>
              <div class="right" v-else>
                <img src="./../../assets/images/icon_ygq.svg" class="yishixiao">
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import weChatShareApi from "../../assets/js/weChatShare";
export default {
  components: {},
  props: {},
  mixins: [weChatShareApi],
  data() {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      myCouponsList: [],
      pageIndex: 0,
      numPerPage: 10
    };
  },
  watch: {},
  methods: {
    onRefresh() {
      this.pageIndex = 0;
      this.finished = false;
      this.myCouponsList = [];
    },
    getdata() {
      let that = this;
      this.$commonPost({
        jydm: "flow_70025",
        flow_70025: {
          user_nbr: this.userInfo.nbr,
          is_use: 1,
          page_index: this.pageIndex * this.numPerPage,
          num_per_page: this.numPerPage
        }
      })
        .then(response => {
          let arr = [];
          if (response.couponlist) {
            if (response.couponlist.length > 0) {
              arr = response.couponlist;
            } else {
              arr.push(response.couponlist);
            }
            if(response.total_rows==response.couponlist.length){
              this.finished = true;
            }else{
              this.pageIndex += 1;
              this.finished = false;
            }
            this.isLoading = false;
              this.loading = false;
          }else{
            this.finished = true;
            this.isLoading = false;
            this.loading = false;
          }
          this.myCouponsList = this.myCouponsList.concat(arr);
        })
        .catch(err => {
          this.isLoading = false;
          this.loading = false;
          this.finished = true;
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    initPage(){
      let option = {
        title: '有米@'+this.userInfo.name+'的店铺',
        desc: "欢迎光临我的店铺",
        link: location.origin + "/?supNbr=" + this.userInfo.nbr,
        images: this.userInfo.imgUrl,
      };
     this.weChatShare(option)
    }
  },
  created() {
    document.title = "历史优惠券";
    this.initPage()
  },
  mounted() {}
};
</script>
<style scoped lang='stylus'>
.wrapper >>> .van-pull-refresh__track {
  min-height: calc(100vh);
}

.wrapper >>> .no {
  margin: 0 auto 0;
  padding-top: 2rem;
  text-align: center;
}
</style>
<style scoped lang='less'>
.wrapper {
  width: 100%;
}

.container {
  background: #fff;
  padding: 0.28rem;
  padding-bottom: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.couponbox {
  width: 6.94rem;
  height: 1.84rem;
  background: #fff7f7;
  display: flex;
  position: relative;
  margin: 0 auto 0.28rem;
  box-sizing: border-box;
  overflow: hidden;
  border-radius: 0.2rem;
}

/* left */
.couponbox .left {
  width: 1.8rem;
  display: flex;
  height: clac(100% - 0.02rem);
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #ffbabf;
  border-right: none;
  border-radius: 0.2rem 0 0 0.2rem;
}

.couponbox .left .top {
  display: flex;
  justify-content: center;
  align-items: baseline;
  font-family: 700;
  font-size: 0.48rem;
  margin-bottom: 0.08rem;
  color: #E52B25;
}

.couponbox .left .top .icon {
  font-size: 0.24rem;
}

.couponbox .left .top .icon.red {
  font-weight: bold;
}

.couponbox .left .bot {
  font-size: 0.24rem;
  color: #999999;
}

/* 线 */
.line {
  width: 0.02rem;
  position: absolute;
  left: 1.8rem;
  z-index: 4;
  height: 100%;
  background: #ffbabf;
}

.line .circle {
  width: 0.2rem;
  height: 0.2rem;
  border-radius: 50%;
  background: #fff;
  position: absolute;
  border: 1px solid #ffbabf;
  left: 50%;
  transform: translateX(-50%);
}

.line .c_t {
  top: -0.1rem;
}

.line .c_b {
  bottom: -0.1rem;
}

/* mid */
.couponbox .mid {
  width: 100%;
  display: flex;
  flex: 1;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  border-top: 1px solid #ffbabf;
  border-bottom: 1px solid #ffbabf;
}

.mid .top {
  font-size: 0.3rem;
  color: #333333;
  margin-bottom: 0.2rem;
}

.mid .bot {
  font-size: 0.24rem;
  color: #999999;
}

/* right */
.couponbox .right {
  width: 1.56rem;
  height: clac(100% - 0.02rem);
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  border: 1px solid #ffbabf;
  border-left: none;
  border-radius: 0 0.2rem 0.2rem 0;
}

.usebtn {
  background: #E52B25;
  box-shadow: 0 0 0 0 #ebebeb;
  border-radius: 0.3rem;
  display: flex;
  height: 0.6rem;
  width: 1.28rem;
  font-family: 700;
  font-size: 0.24rem;
  color: #ffffff;
  justify-content: center;
  align-items: center;
}

.couponbox {
  background: #f5f5f5;
}

.couponbox .left,
.couponbox .mid,
.couponbox .right,
.line .circle {
  border-color: #e3e3e3;
}

.line {
  background: #e3e3e3;
}

.couponbox .left .top {
  color: #333;
}

image.yishixiao {
  width: 1.6rem;
  height: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/information/couponhistory.vue